/** Permissions that open (part of) the owner's settings area. */
export const ACCOUNT_SETTINGS_PERMISSIONS: readonly string[] = [
  'company:manage',
  'users:manage',
  'roles:manage',
  'arca:configure',
];

export interface ModuleEntry {
  label: string;
  icon: string;
  route: string;
}

/**
 * Catalog module key (as in `landing.modulePriority`) -> where it lives in
 * the app. Used by "Inicio" and by the 403 screen.
 */
export const MODULE_ENTRIES: Readonly<Record<string, ModuleEntry>> = {
  sales: { label: 'Ventas', icon: 'shopping_basket', route: '/sales' },
  orders: { label: 'Presupuestos', icon: 'request_quote', route: '/orders' },
  appointments: {
    label: 'Turnos',
    icon: 'calendar_month',
    route: '/calendar',
  },
  customers: {
    label: 'Clientes',
    icon: 'manage_accounts',
    route: '/settings/customers',
  },
  vehicles: { label: 'Vehículos', icon: 'garage', route: '/settings/vehicles' },
  products: {
    label: 'Productos',
    icon: 'inventory_2',
    route: '/settings/products',
  },
  jobs: { label: 'Servicios', icon: 'car_repair', route: '/settings/jobs' },
  suppliers: {
    label: 'Proveedores',
    icon: 'local_shipping',
    route: '/settings/suppliers',
  },
  purchases: { label: 'Compras', icon: 'shopping_cart', route: '/purchases' },
  expenses: { label: 'Gastos', icon: 'trending_down', route: '/expenses' },
  'customer-accounts': {
    label: 'Ctas. corrientes',
    icon: 'account_balance_wallet',
    route: '/account-statement',
  },
  'supplier-accounts': {
    label: 'Ctas. corrientes de proveedores',
    icon: 'account_balance_wallet',
    route: '/account-statement/suppliers',
  },
  treasury: { label: 'Tesorería', icon: 'point_of_sale', route: '/treasury' },
  invoices: { label: 'Facturación', icon: 'receipt_long', route: '/billing' },
  promotions: {
    label: 'Promociones',
    icon: 'percent',
    route: '/settings/promotions',
  },
};

export interface ResolvedModuleEntry extends ModuleEntry {
  key: string;
}

/** Known entries of a `modulePriority` list, in the same order. */
export function resolveModuleEntries(
  keys: readonly string[],
): ResolvedModuleEntry[] {
  return keys
    .filter((key) => !!MODULE_ENTRIES[key])
    .map((key) => ({ key, ...MODULE_ENTRIES[key] }));
}
